import { render, staticRenderFns } from "./RH_BIM_MODEL.vue?vue&type=template&id=55bb9925&scoped=true"
import script from "./RH_BIM_MODEL.vue?vue&type=script&lang=js"
export * from "./RH_BIM_MODEL.vue?vue&type=script&lang=js"
import style0 from "./RH_BIM_MODEL.vue?vue&type=style&index=0&id=55bb9925&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bb9925",
  null
  
)

export default component.exports